import React from 'react'
import { useRouter } from 'next/router'
import { ItemListElements } from 'next-seo/lib/types'

import 'project/polyfill'
import SeoContainer, {
  SeoContainerProps,
} from 'components/util/containers/SeoContainer'
import Strings from 'project/localisation'
import HoxtonMixLogo from 'components/icons/HoxtonMixLogo'
import useWindowSize from 'components/util/useWindowSize'
import { legalStrings } from 'common/strings/legal-strings'
import { NextPageWithLayout } from '../types/nextPageWithLayout'
import PartnerHeroBanner from 'components/hero/PartnerHeroBanner'
import { homeBreadcrumb } from 'components/util/containers/Breadcrumbs'
import LegalDocumentSection from 'components/sections/LegalDocumentSection'

export type PageType = {}
const Page: NextPageWithLayout<PageType> = () => {
  const size = useWindowSize()

  const { locale } = useRouter()
  const seoProps: SeoContainerProps['seoProps'] = {
    description: legalStrings.seoTermsAndConditionsDescription,
    openGraph: {
      url: 'https://www.hoxtonmix.com/terms-and-conditions/',
    },
    title: legalStrings.seoTermsAndConditionsTitle,
  }
  const breadcrumb: ItemListElements[] = [
    homeBreadcrumb()[0],
    {
      item: 'https://www.hoxtonmix.com/terms-and-conditions/',
      name: `${Strings.termsAndConditions}`,
      position: 2,
    },
  ]
  return (
    <SeoContainer
      alternate={[
        { href: '/au/terms-and-conditions', lang: 'en-au' },
        { href: '/terms-and-conditions', lang: 'en-gb' },
      ]}
      breadcrumb={breadcrumb}
      seoProps={seoProps}
    >
      <main className={'overflow-hidden'}>
        <PartnerHeroBanner
          partnershipLogo={
            <HoxtonMixLogo
              className='mb-6 mb-lg-4 max-w-100'
              height={92}
              width={774}
            />
          }
          title={
            <>
              Virtual Office Terms <br /> and Conditions
            </>
          }
          robotImage={{
            height: 878,
            src: '/images/new/robot-holding-mail.png',
            width: 681,
          }}
          robotImageMobile={{
            height: 506,
            src: '/images/new/robot-holding-mail.png',
            width: 392,
          }}
          imageContainerWidth={size.isLgOrHigher ? '43%' : '100%'}
          description=''
        />

        <div className='container'>
          <LegalDocumentSection
            title={legalStrings.termsAndConditionsTitle}
            subtitle={legalStrings.termsAndConditionsSubtitle}
            content={legalStrings.termsAndConditionsDescription}
            documentTitle={`${Strings.termsAndConditions}`}
            documentSize={188}
            documentPath={`/terms_and_conditions_${locale}.pdf`}
            contentStyle={{
              maxWidth: 987,
            }}
          />
        </div>
      </main>
    </SeoContainer>
  )
}

export default Page
